var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { FeatureFlag } from "healthex-common/features.dtos";
import { computed, observable, reaction } from "mobx";
import { NOT_LOADED, ParameterizedRemoteData } from "../Infra/RemoteData";
import { NamedRoutes } from "./NamedRoutes";
export class AdminOrganizationSettingsViewModel {
    constructor(container) {
        this.editingOrganizationDetails = false;
        this.editingLoginSettings = false;
        this.editingPasswordSettings = false;
        this.editingIdpConfig = false;
        this.adminUIManager = container.adminUIManager;
        this.routingUIManager = container.routingUIManager;
        this.organizationsManager = container.organizationsManager;
        this.featureService = container.featureService;
        this.invalidationManager = container.invalidationManager;
        this.myOrganizationFeatures = new ParameterizedRemoteData(this.invalidationManager, () => this.myOrganizationId, async (orgId) => (orgId ? await this.featureService.getFeaturesForOrganization(orgId) : null));
        reaction(() => this.adminUIManager.sectionToExpand, async () => {
            this.expandSectionIfNecessary();
        }, { fireImmediately: true });
    }
    get myOrganizationId() {
        var _a;
        const organization = this.organizationsManager.myOrganization.value;
        if (organization === NOT_LOADED)
            return null;
        return (_a = organization === null || organization === void 0 ? void 0 : organization.id) !== null && _a !== void 0 ? _a : null;
    }
    get ssoEnabled() {
        var _a;
        const organization = this.organizationsManager.myOrganization.value;
        if (organization === NOT_LOADED)
            return NOT_LOADED;
        return (_a = organization === null || organization === void 0 ? void 0 : organization.ssoEnabled) !== null && _a !== void 0 ? _a : false;
    }
    get showIdpConfigSection() {
        const features = this.myOrganizationFeatures.value;
        if (features === NOT_LOADED || features === null)
            return false;
        return features.some((f) => f.feature === FeatureFlag.HOSTED_IDP_SSO_ENABLED && f.enabled);
    }
    expandSectionIfNecessary() {
        if (this.adminUIManager.sectionToExpand === "DETAILS") {
            this.toggleEditingOrganizationDetails();
        }
        else if (this.adminUIManager.sectionToExpand === "AUTHENTICATION") {
            this.toggleLoginSettings();
        }
    }
    newUser() {
        this.routingUIManager.navigateTo(NamedRoutes.ADMIN_USERS_CREATE);
    }
    viewUserDetails(userId) {
        this.adminUIManager.navigateToUserDetails(userId);
    }
    toggleEditingOrganizationDetails() {
        this.editingOrganizationDetails = !this.editingOrganizationDetails;
    }
    toggleLoginSettings() {
        this.editingLoginSettings = !this.editingLoginSettings;
    }
    togglePasswordSettings() {
        this.editingPasswordSettings = !this.editingPasswordSettings;
    }
    toggleIdpConfig() {
        this.editingIdpConfig = !this.editingIdpConfig;
    }
    async onLoginSettingsSave() {
        this.toggleLoginSettings();
        await this.organizationsManager.waitForReloadOrganizations();
    }
    async onPasswordSettingsSave() {
        this.togglePasswordSettings();
        await this.organizationsManager.waitForReloadOrganizations();
    }
    async onIdpConfigSave() {
        this.toggleIdpConfig();
        await this.organizationsManager.waitForReloadOrganizations();
    }
}
__decorate([
    observable
], AdminOrganizationSettingsViewModel.prototype, "editingOrganizationDetails", void 0);
__decorate([
    observable
], AdminOrganizationSettingsViewModel.prototype, "editingLoginSettings", void 0);
__decorate([
    observable
], AdminOrganizationSettingsViewModel.prototype, "editingPasswordSettings", void 0);
__decorate([
    observable
], AdminOrganizationSettingsViewModel.prototype, "editingIdpConfig", void 0);
__decorate([
    computed
], AdminOrganizationSettingsViewModel.prototype, "myOrganizationId", null);
__decorate([
    computed
], AdminOrganizationSettingsViewModel.prototype, "ssoEnabled", null);
__decorate([
    computed
], AdminOrganizationSettingsViewModel.prototype, "showIdpConfigSection", null);
